import React, { ChangeEvent } from "react"
import { toHalfWidth } from "~/utils/ExtendFunctions"

/*
    半角数字入力用コンポーネント
    props
        placeholder:入力エリアに表示するプレースホルダー
        min:入力に必要な最低文字数
        max:入力できる最高文字数
        value:初期値として入れたい値
        required:入力必須かどうかの真偽値
 */

interface Props {
  id?: string,
  name?: string,
  value: number | null,
  placeholder?: string,
  min?: number,
  max?: number,
  required?: boolean,
  className?: string,
  readOnly?: boolean,
  onChange?: (value: number | null) => void,
}

export function NumericText(props: Props) {
  const { id, name, value, placeholder, min, max, required = false, className = "", readOnly, onChange } = props
  return (
    <input type="text"
      id={id}
      name={name}
      style={{ textAlign: "right" }}
      className={`form-control ${className}`}
      defaultValue={value === null ? "" : value}
      placeholder={placeholder}
      minLength={min}
      maxLength={max}
      required={required}
      readOnly={readOnly}
      onBlur={(e: ChangeEvent<HTMLInputElement>) => {
        if (min && (e.target.value === "" || e.target.value === null || e.target.value === undefined)) {
          e.target.value = String(min)
        }
      }}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        e.target.value = toHalfWidth(e.target.value)
        e.target.value = e.target.value.replace(/[^\d]/ig, "")
        if (e.target.value) {
          const n = Number(e.target.value)
          if (min) {
            if (n < min) {
              e.target.value = String(min)
            }
          }
          if (max) {
            if (n > max) {
              e.target.value = String(max)
            }
          }
        }
        const value = (e.target.value === null || e.target.value === "" || e.target.value === undefined) ? null : Number(e.target.value)
        e.target.value = Number.isInteger(value) ? String(value) : ""
        onChange?.apply(this, [value])
      }}
    />
  )
}
